import idbGeneral from "./indexeddb/stores/general";

//The code deploys a single class named AppConfig

export default class AppConfigClass {

	appconfig = null;

	colors = {
		blue: '#3b82f6',
		green: '#22c55e',
		yellow: '#ffc107',
		amber: '#f97316',
		red: '#ef4444',
		purple: '#6f42c1',
		pink: '#e83e8c',
		teal: '#20c997',
		cyan: '#17a2b8',
		brown: '#956b46'
	}

	constructor() {
		/*This initializes an object by first checking if there is an
		appconfig value in localStorage. If so, it is used to initialize the appconfig
		property of the object. Otherwise, the getConfigFromIDB() method is called to retrieve
		the appconfig value from IndexedDB (IDB), which is an local databse in the browser.*/

		//console.log('Config constructor');
		var lsappconfig = localStorage.getItem('appconfig')
		if(lsappconfig){
			this.appconfig = JSON.parse(lsappconfig);
		} else {
			this.getConfigFromIDB();
		}
  	}

  	hasConfig() {
  		//This checks is there is an existing appconfig variable and returns a boolean
  		if(this.appconfig){
  			return true;
  		}
  		return false;
  	}

  	getConfigFromIDB() {
  		/*Retrieves the appconfig object from the browser's IDB
	and stores it in the localStorage (another type of storage in the browser) for future use.*/
  		idbGeneral.getValue('appconfig').then(result => {
			localStorage.setItem('appconfig', JSON.stringify(result));
			this.appconfig = result;
		});
  	}

/*This method sends an HTTP POST request to a specified URL and updates
 some properties of an object depending on the response from the server.
It also logs error messages and invokes callback functions if provided.
See below for a more detailed breakdown*/

	getConfig(callback=null, errorcallback=null) {
		//getConfig has two optional callback parameters.

		//console.log('Getting config');

		/*It will return the output of calling $cfectch with the following arguments.
		This will send an HTTP POST to the URL.*/
		return this.$cfetch(`${this.$settings.APIBaseURL}/getconfig`,
			{
				cache: true,
				method: "post",
			})
			.then(json => {
				/*If the promise is fulfilled, then the response from the server will
				be fetched on a JSON object */

				if (json.status === "SUCCESS") {

					/*If the json was fetched, then this will update the appconfig property with
					the value of json.config. It also saves the value of json.config to localStorage
					and to an IndexedDB database using a method called idbGeneral.updateValue.
					If a callback parameter was provided, the function summons it.*/

					this.$config.appconfig = json.config;
					localStorage.setItem('appconfig', JSON.stringify(json.config));
					idbGeneral.updateValue(
						'appconfig' ,
						json.config
					);
					if(callback){
						callback()
					}
				} else {
					//If fetching the JSON fails, then the error is logged and a callback functions may be summoned.
					this.$log.error.call(this, "Could not fetch config");
					if(errorcallback){
						errorcallback()
					}
				}
			})
			.catch(error => {
				//If something goes wrong during the HTTP request, then the error is logged.
				this.$log.error.call(this, error);
				if(errorcallback){
					errorcallback()
				}
			});
	}

	getValue(key) {
		//If the array appconfig has a key it returns its value, if not, it returns a null instead.

		//this.getConfig();
		//console.log('config value requested by UI ' + JSON.stringify(this.appconfig));

		if(this.appconfig){
			if(key in this.appconfig){
				return this.appconfig[key];
			}
		}
		/*
		 else {
			this.getConfig().then(() => {
				if(key in this.config){
					return this.config[key];
				}
			});
		}
		*/
		return null;
	}

	updateValue(key, value) {
		//Updates the value of the key
		this.appconfig.key = value;
		return true;
	}

	hasModule(name) {
		//Checks if the argument is listed amongst the modules.
		const modules = this.getValue('modules');
		if(modules){
			return modules.includes(name);
		}
		return false;
	}

/*The next two functions work together, the first takes an ID
and returns the programme name as an object, then the second
check if the programme exists, in which case it will return its name as a string.
Otherwise, we get a null.*/

	getProgrammeById(id) {
		const programmes = this.getValue('programmes');
		if(id in programmes) {
			return programmes[id];
		}
		return false;
	}

	getProgrammeNameById(id) {

		const programme = this.getProgrammeById(id);
		return programme ? programme.Name : null;

	}

	getFirmNameById(id) {
		//Retrieve the name of a firm given its id by looking up the id in an object of firm data.
		//If the id is found, the function returns the corresponding name; otherwise, it returns an empty string.
		let firms = this.getValue('firms');
		if(id in firms){
			return firms[id];
		}
		return '';
	}

	getGroupNameById(id) {
		//Same functionality as getFirmNameById.
		let groups = this.getValue('groups');
		if(id in groups){
			return groups[id];
		}
		return '';
	}

	getTagById(id) {
		for(let tag of this.getValue('tags')) {
			if(tag.id == id) {
				return tag;
			}
		}
		return null;
	}

	getUserYearStr(user) {
		/*It takes a single argument, which is the user. Then, it returns how many years they have been enroled
		in the programme. If they user has graduated, it also returns a string indicating that.*/
		const programme = this.getProgrammeById(user.programme);
		if(parseInt(user.year) > parseInt(programme.CourseLengthYears)) {
			return 'Graduated';
		}
		return user.year;
	}

	getYearStr(year, programmeId) {
		const programme = this.getProgrammeById(programmeId);

		if (parseInt(year) > parseInt(programme.CourseLengthYears)) {
			return 'Graduated'
		}
		return parseInt(year)
	}

	getProgrammeYears(programmeId, includeGraduated=false) {
		const programme = this.getProgrammeById(programmeId);
		if (!programme) return [];

		const years = [];
		let i = 1;
		for (; i <= programme.CourseLengthYears; i++) years.push(i);
		if (includeGraduated) years.push(i)

		return years;
	}

	getTermById(id) {
		//Same functionality as getFirmNameById, however, in case of failure it will return a false value.
		const terms = this.getValue('terms');
		if(id in terms) {
			return terms[id];
		}
		return false;
	}

	getTermNameById(id) {
		/*It takes an id and it checks whether a term is associated to it or not. If so, then it returns
		the title of the school term. Otherwise, we get a null.*/
		const term= this.getTermById(id);
		return term ? term.schoolterm_title : null;

	}

	getSpecialtyById(id) {
		//First, it retrieves an array of specialties by calling getValue with the argument 'specialties'.
		const specialties = this.getValue('specialties');

		//Then, it initializes the selspecialty variable
		var selspecialty = null;
		/*Finally, it loops through the specialties array using the forEach method to find a specialty with the given id.
		If found, the function sets selspecialty variable to that specialty object. If not, selspecialty remains null.*/

		specialties.forEach(specialty => {
			if(specialty.id == id){
				selspecialty = specialty;
			}
		});
		return selspecialty;
	}

	getSpecialtyNameById(id) {
		//Same functionality as getTermNameById
		const specialty= this.getSpecialtyById(id);
		return specialty ? specialty.name : null;

	}

	getParticipationTypeById(id) {
		//First, it retrieves an array of specialties by calling getValue with the argument 'specialties'.
		const items = this.getValue('participationTypes');

		//Then, it initializes the selspecialty variable
		var selitem = null;
		/*Finally, it loops through the specialties array using the forEach method to find a specialty with the given id.
		If found, the function sets selspecialty variable to that specialty object. If not, selspecialty remains null.*/

		items.forEach(item => {
			if(item.id == id){
				selitem = item;
			}
		});
		return selitem;
	}

	getParticipationTypeNameById(id) {
		//Same functionality as getTermNameById
		const item = this.getParticipationTypeById(id);
		return item ? item.name : null;

	}

	getClinicById(id) {
		//First, it retrieves an array of specialties by calling getValue with the argument 'specialties'.
		const items = this.getValue('clinics');

		//Then, it initializes the selspecialty variable
		var selitem = null;
		/*Finally, it loops through the specialties array using the forEach method to find a specialty with the given id.
		If found, the function sets selspecialty variable to that specialty object. If not, selspecialty remains null.*/

		items.forEach(item => {
			if(item.id == id){
				selitem = item;
			}
		});
		return selitem;
	}

	getClinicNameById(id) {
		//Same functionality as getTermNameById
		const item = this.getClinicById(id);
		return item ? item.name : null;

	}

	getColors() {
		return this.colors;
	}

	getColorHexByName(name) {
		if(name in this.colors){
			return this.colors[name];
		}
		return null;
	}

	getColorHexByIndex(index) {
		index = (index % Object.keys(this.colors).length);
		return this.colors[Object.keys(this.colors)[index]];
	}

}
